/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const ArrowTop16 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path fill="currentColor" fillRule="evenodd" d="m13.067 12 1.433-1.445L8 4l-6.5 6.555L2.933 12 8 6.891z" />
  </svg>
);

export const __descriptor_ArrowTop = {
  name: "ArrowTop",
  instances: [{ size: 16, Component: ArrowTop16 }],
} as const;
